export const filterByApplicableSrTypes = (array, srType) => {
  if (!Array.isArray(array)) return [];
  return array.filter((item) => {
    // Check for new property names first, then fall back to old ones
    // TODO: delete fallback in SYSAID-13377
    const types = item?.types ?? item?.applicableSrTypes;
    const visible = item?.visible ?? item?.visibleToUser;
    return types?.includes(Number(srType)) && !!visible;
  });
};
export const convertObjectToArray = (obj) => Object.values(obj ?? {});

export function mapValuesById(array) {
  return array.reduce((acc, item) => {
    const transformedValues = {};
    item.values?.forEach((innerItem) => {
      transformedValues[innerItem.id] = innerItem;
    });

    acc[item.id] = {
      ...item,
      values: transformedValues || {},
    };
    return acc;
  }, {});
}

export const mapNestedItemsByExactLevelAndSort = (data, targetLevel = 1) => {
  const result = [];
  const seenIds = new Set();

  function traverse(items, currentLevel) {
    if (currentLevel > targetLevel) return;

    for (const item of items) {
      // Ensure item.values is an array of objects
      const values = Array.isArray(item.values)
        ? item.values
        : Object.entries(item.values || {}).map(([key, value]) => ({ id: key, ...value }));

      if (currentLevel === targetLevel) {
        if (!seenIds.has(item.id)) {
          result.push({ ...item, values, level: currentLevel });
          seenIds.add(item.id);
        }
      } else if (values.length) {
        traverse(values, currentLevel + 1);
      }
    }
  }

  traverse(data, 1);
  return result.sort((a, b) => a.value.localeCompare(b.value));
};

export const createCategoryIdToNameMap = (categoryList) => {
  const categoryIdToNameMap = {};

  function traverse(categories) {
    if (!categories) return;

    const categoriesArray = Object.values(categories);

    for (const categoryObj of categoriesArray) {
      if (categoryObj?.id) {
        categoryIdToNameMap[categoryObj.id] = categoryObj.value;
      }
      // Recursively traverse nested values
      if (categoryObj?.values) {
        traverse(categoryObj.values);
      }
    }
  }

  traverse(categoryList);
  return categoryIdToNameMap;
};
